import React from "react";
import { useHistory } from "react-router-dom";

export const AuthContext = React.createContext();
export default function AuthProvider({ children }) {
  const history = useHistory();

  return <AuthContext.Provider value={{}}>{children}</AuthContext.Provider>;
}
